<div id="dialog-container" class="fx-layout-col" [cdkTrapFocus]="true">
  <mat-dialog-content class="fx-flex-auto fx-layout-col fx-justify-center fx-align-center">
    <mat-icon fontSet="mdi" [fontIcon]="iconName" [style.color]="colour" class="lg m-b-10"></mat-icon>
    <h3 id="title" class="modal-title">{{ title }}</h3>
    <div id="message" class="modal-message">
      @if (code) {
        <div>
          <span>{{ "LABEL.ERROR_CODE" | translate }}</span>
          <span class="error-code">{{ code }}</span>
        </div>
      }
      <div>{{ message }}</div>
    </div>
    @if (stackTrace) {
      <pre class="error-stack-trace">{{ stackTrace }}</pre>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <a mat-stroked-button href="https://tbmaestro.atlassian.net/servicedesk" target="_blank">
      <mat-icon fontSet="material-icons" fontIcon="open_in_new"></mat-icon>
      {{ 'BUTTON.CONTACT_US' | translate }}
    </a>
    <button mat-stroked-button (click)="onClickLogout()">
      <mat-icon fontSet="material-icons" fontIcon="logout"></mat-icon>
      {{ 'BUTTON.LOGOUT' | translate }}
    </button>
    <button mat-raised-button matDialogClose="yes" color="accent" id="dialog-ok-button">{{ okText }}</button>
  </mat-dialog-actions>
</div>
